import { useAppState } from '../context/State';
import { LOCALE_MAPPING } from '../constants';

export const GetCopy = ({ copy = null }) => {
  const state = useAppState();
  let locale = state.locale;
  
  // Apply locale mapping
  locale = LOCALE_MAPPING[locale] || locale;
  if (copy === null) {
    locale = 'EN';
  }
  let copyState = state.copy;
  copyState = Object.fromEntries(
    Object.entries(copyState).map(([sectionName, sectionData]) => [
      sectionName,
      Object.fromEntries(
        Object.values(sectionData)
          .filter(entry => typeof entry?.name === 'string' && typeof entry?.value === 'string' && entry.value.trim() !== '')
          .map(entry => [entry.name, entry.value])
      )
    ])
  );
  const text = copyState[copy]?.[locale];
  return text ? text : null;
};
